import React from "react";
import "./eng-title.css";

const EngTitle = (props) => {
  return <span className="eng-name">{props.title}</span>;
};

export default EngTitle;